import { Modal } from "@/components/common/Modal";
import { ATAJOS, destinoPorId, type Rol } from "@/routes/routeConfig";
import styles from "./ShortcutsHelp.module.css";

interface ShortcutsHelpProps {
  rol: Rol;
  onClose: () => void;
}

const COMUNES: Array<[string, string]> = [
  ["Ctrl/Cmd K", "Buscar cliente, sección o acción"],
  ["?", "Esta ayuda"],
  ["Esc", "Cerrar la capa superior"],
];

/** `?`: ayuda de atajos. Los números llevan a las secciones del cliente, en el orden de SU rol. */
export function ShortcutsHelp({ rol, onClose }: ShortcutsHelpProps) {
  const globales: Array<[string, string]> = rol === "agency" ? [...COMUNES, ["Shift F", "Abrir «Parar cambios»"]] : COMUNES;
  return (
    <Modal label="Atajos de teclado" onClose={onClose}>
      <ul className={styles.list}>
        {ATAJOS[rol].map((id, index) => (
          <li key={id} className={styles.item}>
            <span>{destinoPorId(id).label}</span>
            <kbd className={styles.key}>{index + 1}</kbd>
          </li>
        ))}
        {globales.map(([key, label]) => (
          <li key={key} className={styles.item}>
            <span>{label}</span>
            <kbd className={styles.key}>{key}</kbd>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
